/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Bring_S2_CapInputs */

const en_funnel_ob_bring_s2_cap = /** @type {(inputs: Funnel_Ob_Bring_S2_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turned into natural audio.`)
};

const es_funnel_ob_bring_s2_cap = /** @type {(inputs: Funnel_Ob_Bring_S2_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertido en audio natural.`)
};

/**
* | output |
* | --- |
* | "Turned into natural audio." |
*
* @param {Funnel_Ob_Bring_S2_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_bring_s2_cap = /** @type {((inputs?: Funnel_Ob_Bring_S2_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Bring_S2_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_bring_s2_cap(inputs)
	return en_funnel_ob_bring_s2_cap(inputs)
});